const socialmedia = [
  {
    id: 1,
    label: 'Instagram',
    icon: 'fa-brands fa-instagram',
    url: 'https://www.instagram.com/properties_in_finite/',
    is_show: true,
  },
  {
    id: 2,
    label: 'Facebook',
    icon: 'fa-brands fa-facebook-f',
    url: 'https://www.facebook.com/share/1DqJbpvacC/',
    is_show: true,
  },
  {
    id: 3,
    label: 'YouTube',
    icon: 'fa-brands fa-youtube',
    url: 'https://www.youtube.com/@PropertiesInfinite',
    is_show: true,
  },
];

export default socialmedia;